import { Controller } from '@hotwired/stimulus';
import Logger from '../lib/logger';
class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.collapseElement = null;
    }
    connect() {
        Logger.debug('PersistCollapseController connected', { controller: this.constructor.name });
        if (!this.keyValue) {
            Logger.warn('PersistCollapseController needs a key value to persist state');
            return;
        }
        this.collapseElement = this.element;
        this._boundSaveState = this.saveState.bind(this);
        this._boundBeforeMorph = this.handleBeforeMorph.bind(this);
        // Listen to Bootstrap collapse events
        this.collapseElement.addEventListener('shown.bs.collapse', this._boundSaveState);
        this.collapseElement.addEventListener('hidden.bs.collapse', this._boundSaveState);
        // Listen to Turbo morph events to preserve state during broadcast refreshes
        document.addEventListener('turbo:before-morph-element', this._boundBeforeMorph);
        this.restoreState();
    }
    disconnect() {
        Logger.debug('PersistCollapseController disconnected', { controller: this.constructor.name });
        if (this.collapseElement) {
            this.collapseElement.removeEventListener('shown.bs.collapse', this._boundSaveState);
            this.collapseElement.removeEventListener('hidden.bs.collapse', this._boundSaveState);
        }
        document.removeEventListener('turbo:before-morph-element', this._boundBeforeMorph);
    }
    handleBeforeMorph(event) {
        const target = event.target;
        const newElement = event.detail.newElement;
        // Preserve the collapse container state
        if (target === this.collapseElement) {
            const isExpanded = this.collapseElement.classList.contains('show');
            if (isExpanded) {
                newElement.classList.add('show');
            }
            else {
                newElement.classList.remove('show');
            }
        }
        // Preserve the toggle button state
        if (this.collapseElement?.id &&
            (target.getAttribute('aria-controls') === this.collapseElement.id ||
                target.getAttribute('data-bs-target') === `#${this.collapseElement.id}`)) {
            const isExpanded = target.getAttribute('aria-expanded');
            if (isExpanded) {
                newElement.setAttribute('aria-expanded', isExpanded);
            }
        }
    }
    saveState() {
        const isExpanded = this.collapseElement?.classList.contains('show');
        sessionStorage.setItem(this.storageKey, isExpanded ? 'true' : 'false');
        Logger.debug('Saved collapse state', { key: this.storageKey, isExpanded });
    }
    restoreState() {
        const storedState = sessionStorage.getItem(this.storageKey);
        if (storedState === 'true') {
            this.collapseElement?.classList.add('show');
            this.updateToggles(true);
        }
        else if (storedState === 'false') {
            this.collapseElement?.classList.remove('show');
            this.updateToggles(false);
        }
    }
    updateToggles(isExpanded) {
        const id = this.collapseElement?.id;
        if (!id)
            return;
        // Find all toggles that control this collapse
        const toggles = document.querySelectorAll(`[data-bs-target="#${id}"], [aria-controls="${id}"]`);
        toggles.forEach(toggle => {
            toggle.setAttribute('aria-expanded', isExpanded.toString());
        });
    }
    get storageKey() {
        return `collapse-state-${this.keyValue}`;
    }
}
default_1.values = {
    key: String
};
export default default_1;
